import {
    NOTIFICATION_ITEM_RESPONSE,
    NOTIFICATION_LIST_RESPONSE,
    UNAUTHENTICATED,
} from "../../actions/action-types"
import { normalise } from "../../models/entities/notification"
import { extractEntitiesFromData } from "./entity-reducer-utils"

export default (state = {}, action) => {
    const { type, data, receivedAt } = action
    switch (type) {
        case NOTIFICATION_ITEM_RESPONSE:
            const { id } = data
            return {
                ...state,
                [id]: {
                    ...normalise(data),
                    lastUpdatedAt: receivedAt,
                },
            }
        case NOTIFICATION_LIST_RESPONSE:
            return extractEntitiesFromData(data, state)
        case UNAUTHENTICATED:
            return {}
        default:
            return state
    }
}
